// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.XL9ag.AlYmu{opacity:.7}.qRWEI{background-color:var(--bg-standard, #f3f5ff);border-radius:8px;padding:16px 20px;color:var(--text-standard, #282863)}.R60L0{flex:1;min-width:0}.dmEzB{height:24px}.VHvjd{width:75px;display:flex;justify-content:center}.WKhx2,.EiT5n{list-style-type:none;padding:0 8px;margin:0}.WKhx2 li,.EiT5n li{display:flex;align-items:baseline;gap:8px}.WKhx2 li::before,.EiT5n li::before{content:"•";color:var(--text-secondary, #9393b1);font-size:10px;flex-shrink:0}.jSLqV{height:48px;align-items:center}.jjBOj{margin-top:16px}.HkYDm{color:#9393b1}.c0ixM{padding:0 16px 24px}.Wy59i{background:color-mix(in srgb, var(--button-primary, #6942f8) 15%, white) !important;border-color:var(--button-primary, #6942f8) !important;color:var(--button-primary, #6942f8) !important}.Wy59i *{color:inherit !important}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"blue45": `#fcfcff`,
	"blue48": `#f5f7fd`,
	"blue50": `#f3f5ff`,
	"blue300": `#dae0ff`,
	"blue500": `#c0caff`,
	"blue600": `#a1aef5`,
	"blue700": `#8296ff`,
	"blue800": `#6176e7`,
	"dark50": `#fcfcfd`,
	"dark70": `#f4f4f7`,
	"dark100": `#eaeaef`,
	"dark120": `#e4e4ec`,
	"dark200": `#d4d4e0`,
	"dark300": `#bfbfd0`,
	"dark400": `#a9a9c1`,
	"dark500": `#9393b1`,
	"dark600": `#7e7ea1`,
	"dark700": `#696992`,
	"dark800": `#535382`,
	"dark900": `#282863`,
	"green45": `#eff6fa`,
	"green50": `#f3fcfa`,
	"green300": `#b6ebdf`,
	"green500": `#86ddca`,
	"green700": `#56d0b5`,
	"green800": `#36b89b`,
	"green900": `#089475`,
	"orange50": `#fdf2dc`,
	"orange300": `#fadea8`,
	"orange500": `#f9d797`,
	"orange700": `#f7ca75`,
	"orange800": `#f5bd52`,
	"orange900": `#dd9306`,
	"purple50": `#e1d9fe`,
	"purple300": `#c3b3fc`,
	"purple500": `#a58efb`,
	"purple700": `#8768f9`,
	"purple800": `#6942f8`,
	"purple900": `#4520cc`,
	"red200": `#fdf0f0`,
	"red300": `#fee3e3`,
	"red500": `#f9d5d5`,
	"red700": `#f3aaaa`,
	"red900": `#eb7272`,
	"red950": `#e86161`,
	"red970": `#dd4c4c`,
	"white": `#fff`,
	"defaultTextStandard": `#282863`,
	"defaultTextSecondary": `#696992`,
	"defaultButtonPrimary": `#6942f8`,
	"buttonPrimary": `var(--button-primary, #6942f8)`,
	"buttonPrimaryDark": `var(--button-primary-dark, #4520cc)`,
	"buttonDisabled": `var(--button-disabled, #bfbfd0)`,
	"buttonDisabledDark": `var(--button-disabled-dark, #a9a9c1)`,
	"defaultButtonDisabled": `#bfbfd0`,
	"defaultStepperCompleted": `#089475`,
	"defaultStepperIncomplete": `#d4d4e0`,
	"defaultButtonSecondary": `#fcfcfd`,
	"defaultBgStandard": `#f3f5ff`,
	"defaultBgLight": `#fff`,
	"serviceItem": `XL9ag`,
	"disabled": `AlYmu`,
	"card": `qRWEI`,
	"serviceName": `R60L0`,
	"viewMoreDivider": `dmEzB`,
	"viewMoreButton": `VHvjd`,
	"includedServicesList": `WKhx2`,
	"detailsList": `EiT5n`,
	"futureBillingCallout": `jSLqV`,
	"expandedContent": `jjBOj`,
	"mobileChevron": `HkYDm`,
	"bottomSheetContent": `c0ixM`,
	"billingBadge": `Wy59i`
};
export default ___CSS_LOADER_EXPORT___;
